<template>
  <section class="layout-marketing">
    <div class="nav-tabs">
      <div
        v-for="item of data"
        :key="item.productId"
        class="item"
        :class="{ 'is-active': currentActiveId === item.productId }"
        @click="handleItemClick(item.productId)"
      >
        <svg-icon :icon-class="`product-icon-${item.productName_zh_CN}`" />
        <span>{{ item.productName }}</span>
      </div>
    </div>
    <div class="content-panes">
      <div
        v-for="item of data"
        :key="item.productId"
        class="item"
        :class="{ 'is-active': currentActiveId === item.productId }"
        :inert="currentActiveId !== item.productId"
      >
        <div class="header">
          <div class="desc">{{ item.memo || item.productName }}</div>
          <action-buttons :product-name="item.productName_zh_CN" />
        </div>
        <div class="body">
          <img
            :src="`${assetsPathBase}/products-fig-${item.productId}.png`"
            :alt="item.memo || item.productName"
            loading="lazy"
            @error="event => (event.target.style.opacity = 0)"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ActionButtons from "./action-buttons.vue";
import { commons } from "./mixin";
export default {
  name: "LayoutMarketing",
  components: {
    ActionButtons
  },
  mixins: [commons],
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      currentActiveId: null
    };
  },
  watch: {
    data: {
      handler(val) {
        this.currentActiveId = val?.[0]?.productId ?? null;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleItemClick(id) {
      this.currentActiveId = id;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/common";
.layout-marketing {
  display: flex;
  gap: 86px;
  padding: 0 32px;
  background-color: #fff;
  border-radius: 8px;
  .nav-tabs {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 200px;
    padding: 24px 0;
    flex-shrink: 0;
    .item {
      cursor: pointer;
      display: flex;
      align-items: center;
      height: 74px;
      gap: 8px;
      padding: 0 24px;
      border-radius: 8px;
      color: #a7aebc;
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
      user-select: none;
      transition: background-color 0.3s, color 0.3s;
      &:hover {
        background-color: #f3f7fb;
      }
      &.is-active {
        color: $color-blue;
        background-color: #e7edff;
      }
      svg {
        width: 24px;
        height: 24px;
      }
    }
  }
  .content-panes {
    margin-top: 48px;
    flex-grow: 1;
    position: relative;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 2px;
      opacity: 0;
      position: absolute;
      inset: 0;
      pointer-events: none;
      transition: opacity 0.3s;
      &.is-active {
        pointer-events: auto;
        opacity: 1;
      }
      .header {
        .desc {
          margin-bottom: 4px;
          color: $color-text-regular;
          font-size: 14px;
          line-height: 22px;
        }
      }
      .body {
        flex-grow: 1;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          margin-left: -4%;
          object-fit: contain;
          object-position: left top;
          user-select: none;
          pointer-events: none;
          position: absolute;
          inset: 0;
        }
      }
    }
  }
}
</style>
